import Tabby from 'tabbyjs';
import initCarousel from './carousel';

const tabsSelector = '[data-page-tabs]';

if (document.querySelector(tabsSelector)) {
    Tabby(tabsSelector);

    // keep url up to date with displayed tab
    document.addEventListener('tabby', (event) => {
        const href = event.target.getAttribute('href');
        const id = event.target.getAttribute('aria-controls');
        if (window.history.replaceState) {
            // pushState does not work with the back button when swapping between tabs
            window.history.replaceState(null, null, href);
        } else {
            // will cause a window scroll in browsers that do not support replaceState
            window.location = href;
        }

        // initiate any carousel inside the new tab
        const carousels = document.getElementById(id).querySelectorAll('.glide');
        carousels.forEach(initCarousel);
    }, false);
}
